import { node, object } from "prop-types";
import React, { createContext, useContext, useReducer } from "react";

import userProfileActions from "./actions";

const defaultState = {
  reloadFamily: 0,
  fname: null,
  lname: null,
  isArchived: false,
  familyData: {
    showRelationshipPicker: false,
    relationshipUserID: null,
    hasGivingData: false,
    householdName: "",
    householdID: null,
    suggestedFamilyMembers: [],
    relationships: {},
    saveIndirectRelationships: true,
    relationshipConflicts: [],
    conflictsRelationshipUser: null,
    pendingRelationshipID: null,
    showManageProxyContactsMenu: false,
    manageProxyContactsTargetUserID: 0,
  },
  additionalContactInfo: {
    hasFNP: null,
    showExpandedView: false,
    contactInfo: [],
  },
  userInfo: {},
};

const userProfileAppReducer = (state, action) => {
  let newState = { ...state };
  const { userInfo } = action;

  switch (action.type) {
    case "Reload Family":
      newState.reloadFamily = newState.reloadFamily + 1;
      return newState;

    case "Show Relationship Picker":
      if (action.relationshipUserID)
        newState.familyData.relationshipUserID = action.relationshipUserID;
      newState.familyData.showRelationshipPicker = true;
      newState.familyData.saveIndirectRelationships =
        action.saveIndirectRelationships;
      if (action.relationshipConflicts)
        newState.familyData.relationshipConflicts =
          action.relationshipConflicts;
      if (action.relationshipUser)
        newState.familyData.conflictsRelationshipUser = action.relationshipUser;
      if (action.pendingRelationshipID)
        newState.familyData.pendingRelationshipID =
          action.pendingRelationshipID;
      return newState;

    case "Hide Relationship Picker":
      newState.familyData.relationshipUserID = null;
      newState.familyData.showRelationshipPicker = false;
      newState.familyData.relationshipConflicts = [];
      newState.familyData.conflictsRelationshipUser = null;
      newState.familyData.pendingRelationshipID = null;
      return newState;

    case "Set Profile User Info":
      for (const key in action.payload) {
        newState[key] = action.payload[key];
      }
      return newState;

    case "Set Family Data":
      for (const key in action) {
        if (key !== "type") newState.familyData[key] = action[key];
      }
      return newState;

    case "Show Manage Proxy Contacts":
      newState.familyData.showManageProxyContactsMenu = true;
      newState.familyData.manageProxyContactsTargetUserID = action.targetUserID;
      return newState;

    case "Hide Manage Proxy Contacts":
      newState.familyData.showManageProxyContactsMenu = false;
      newState.familyData.manageProxyContactsTargetUserID = 0;
      return newState;

    case "Expand Additional Contacts":
      newState.additionalContactInfo.showExpandedView = true;
      return newState;

    case "Condense Additional Contacts":
      newState.additionalContactInfo.showExpandedView = false;
      return newState;

    case "Add Additional Contact Info Item":
      newState.additionalContactInfo.contactInfo = [
        ...newState.additionalContactInfo.contactInfo,
        action.newItem,
      ];
      return newState;

    case "Remove Additional Contact Info Item": {
      newState.additionalContactInfo.contactInfo = [
        ...newState.additionalContactInfo.contactInfo.filter(
          (elem) => elem.ID !== action.ID
        ),
      ];
      if (newState.additionalContactInfo.contactInfo.length === 0)
        newState.additionalContactInfo.showExpandedView = false;
      return newState;
    }

    case "Update Additional Contact Info Item": {
      let indexToUpdate = newState.additionalContactInfo.contactInfo.findIndex(
        (elem) => elem.ID === action.ID
      );
      if (indexToUpdate) {
        newState.additionalContactInfo.contactInfo[indexToUpdate].value =
          action.value;
        newState.additionalContactInfo.contactInfo = [
          ...newState.additionalContactInfo.contactInfo,
        ];
      }
      return newState;
    }

    case "Set ACI Data":
      newState.additionalContactInfo.contactInfo = [...action.items];
      newState.additionalContactInfo.hasFNP = action.hasFNP;
      return newState;

    case "Add Empty New Item":
      newState.additionalContactInfo.contactInfo = [
        ...newState.additionalContactInfo.contactInfo,
        {
          ID: -1,
          value: "",
        },
      ];
      return newState;
    case userProfileActions.SET_USER_INFO:
      return { ...state, userInfo };

    default:
      return newState;
  }
};

export const UserProfileState = createContext();

export function UserProfileStateProvider({
  children,
  initialState = defaultState,
}) {
  return (
    <UserProfileState.Provider
      value={useReducer(userProfileAppReducer, initialState)}
    >
      {children}
    </UserProfileState.Provider>
  );
}

UserProfileStateProvider.propTypes = { children: node, initialState: object };

const useUserProfile = () => {
  const context = useContext(UserProfileState);

  if (!context) {
    throw new Error(
      "useUserProfile must be used inside a <UserProfileStateProvider />"
    );
  }

  return context;
};

export { useUserProfile };
